import styled, { css } from "styled-components";
import { PageContextUtils } from "../../../../utils";
import { Theme } from "../../../../constants";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../../../redux/selectors";

const { currentName = Theme.Default } = PageContextUtils.getThemeData();
const NotificationBoxWrapper = styled.div`
  ${() => {
    const isMobile = useSelector(UserContextSelectors.isMobile);
    if (!isMobile) {
      return css`
        margin: 10px;
      `;
    }
  }}
  margin-bottom: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  div:last-child {
    margin-right: 0;
  }
`;

const NotificationBoxItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--charchaol-gray);
  width: 100%;
  height: 8rem;
  border-radius: 4px;
  margin-right: 1rem;
  color: var(--medium-gray);
  transition: all 0.3s;
  text-decoration: none;
  cursor: pointer;
  ${props =>
    props.isAuthenticated &&
    `
   color: var(--gray); 
  `}
  ${props =>
    props.isAuthenticated &&
    props.applyHovverEffect &&
    `
  &:hover {
    color: var(--white);
    cursor: pointer;
    background: var(--dark-gray);
  }`}

${props =>
    !props.isAuthenticated && props.applyHovverEffect && `color: var(--gray);`}

  ${() => {
    switch (currentName) {
      case Theme.MrGreen:
        return css`
          box-sizing: border-box;

          /* MG Dark Green */

          background: #05372c;
          /* MG Medium Green */

          border: 0.5px solid #047c4c;
          box-shadow:
            inset 0 0 20px rgba(255, 255, 255, 0.1),
            inset 0 0 10px #419272;
          border-radius: 5px;
          ${props =>
            props.isAuthenticated &&
            `
            &:hover {
            cursor: pointer;
            background: #015536;
          }
          `}
        `;
      default:
        return null;
    }
  }}
`;

const NotificationBoxItemTitle = styled.span`
  font-family: var(--notification-font);
  font-style: normal;
  font-weight: 600;
  font-size: 1.1rem;
  margin-top: 1.1rem;
  color: ${props => props.color};
`;

export {
  NotificationBoxWrapper,
  NotificationBoxItem,
  NotificationBoxItemTitle
};
